import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _extends from "@babel/runtime-corejs3/helpers/extends";
import _toConsumableArray from "@babel/runtime-corejs3/helpers/toConsumableArray";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof _Object$getOwnPropertySymbols === "function") for (var i = 0, p = _Object$getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import * as React from 'react';
import { ConfigContext } from '../config-provider';
import { getCompProps } from '../_utils';
import classNames from 'classnames';
import { renderReactNodeFunction, DEFAUTL_PADDING } from './util';
import devWarning from '../_utils/devwarning';
export var MENU_ITEM_CONTAINER_NAME = 'menu-item-content-container';
var InternalMenuItem = function InternalMenuItem(props, ref) {
  var _context, _classNames;
  var _React$useContext = React.useContext(ConfigContext),
    getPrefixCls = _React$useContext.getPrefixCls,
    pkgPrefixCls = _React$useContext.prefixCls,
    userDefaultProps = _React$useContext.compDefaultProps;
  // 属性需要合并一遍用户定义的默认属性
  var _a = getCompProps('MenuItem', userDefaultProps, props),
    customPrefixcls = _a.prefixCls,
    icon = _a.icon,
    mode = _a.mode,
    _a$level = _a.level,
    level = _a$level === void 0 ? 1 : _a$level,
    disabled = _a.disabled,
    children = _a.children,
    collapsed = _a.collapsed,
    keyValue = _a.keyValue,
    selectedKey = _a.selectedKey,
    setSelectedKeyPath = _a.setSelectedKeyPath,
    subMenuMode = _a.subMenuMode,
    inlineIndent = _a.inlineIndent,
    className = _a.className,
    handleOnClick = _a.handleOnClick,
    _a$paddingLeft = _a.paddingLeft,
    paddingLeft = _a$paddingLeft === void 0 ? 0 : _a$paddingLeft,
    style = _a.style,
    parentPath = _a.parentPath,
    restProps = __rest(_a, ["prefixCls", "icon", "mode", "level", "disabled", "children", "collapsed", "keyValue", "selectedKey", "setSelectedKeyPath", "subMenuMode", "inlineIndent", "className", "handleOnClick", "paddingLeft", "style", "parentPath"]);
  devWarning(!keyValue && keyValue !== 0, 'menuitem', 'cannot found children in Menu.Item');
  var prefixCls = getPrefixCls(pkgPrefixCls, 'menu-item', customPrefixcls);
  var menuItemRef = ref || /*#__PURE__*/React.createRef();
  var menuItemParentPath = Array.isArray(parentPath) ? _concatInstanceProperty(_context = []).call(_context, _toConsumableArray(parentPath), [keyValue]) : [keyValue];
  var renderItemChildren = function renderItemChildren(children) {
    if (typeof children === 'string') {
      return /*#__PURE__*/React.createElement("span", {
        className: MENU_ITEM_CONTAINER_NAME
      }, children);
    }
    return /*#__PURE__*/React.createElement("div", {
      className: MENU_ITEM_CONTAINER_NAME
    }, typeof children === 'function' ? children() : children);
  };
  var preventClick = function preventClick() {
    return !!(disabled || mode === 'inline');
  };
  var handleOnMouseEnter = function handleOnMouseEnter(e) {
    if (preventClick()) return;
    restProps.onMouseEnter && restProps.onMouseEnter(e);
  };
  var handleOnMouseLeave = function handleOnMouseLeave(e) {
    if (preventClick()) return;
    restProps.onMouseLeave && restProps.onMouseLeave(e);
  };
  var handleOnClickItem = function handleOnClickItem(e) {
    if (disabled) return;
    e.stopPropagation();
    var info = {
      key: keyValue,
      keyPath: menuItemParentPath,
      domEvent: e.nativeEvent
    };
    handleOnClick(info);
  };
  var getPaddingLeft = function getPaddingLeft() {
    if (icon || subMenuMode === 'horizontal') {
      return 0;
    }
    if (level > 1 && mode !== 'inline') {
      return DEFAUTL_PADDING;
    }
    // if (level === 1 && icon) {
    //   return 0
    // }
    // 无图标显示首个字符不需要paddingleft
    if (!icon && collapsed && level === 1 && typeof children === 'string') {
      return 0;
    }
    return inlineIndent + paddingLeft;
  };
  var mouseEvent = {
    onClick: handleOnClickItem,
    onMouseLeave: handleOnMouseLeave,
    onMouseEnter: handleOnMouseEnter
  };
  var titleStyle = {
    paddingLeft: "".concat(getPaddingLeft(), "px"),
    paddingRight: mode !== 'inline' && level > 1 ? "".concat(DEFAUTL_PADDING, "px") : 0
  };
  var renderTitle = function renderTitle() {
    if (!icon && collapsed && level === 1 && typeof children === 'string') {
      return /*#__PURE__*/React.createElement("p", null, children.charAt(0));
    }
    return renderItemChildren(children);
  };
  React.useEffect(function () {
    if (selectedKey && selectedKey === keyValue) {
      setSelectedKeyPath(menuItemParentPath);
    }
  }, [selectedKey]);
  return /*#__PURE__*/React.createElement("li", _extends({
    ref: menuItemRef,
    className: classNames(className, (_classNames = {}, _defineProperty(_classNames, prefixCls, subMenuMode !== 'horizontal'), _defineProperty(_classNames, "".concat(prefixCls, "-collapsed"), collapsed && level === 1), _defineProperty(_classNames, "".concat(prefixCls, "-disabled"), disabled), _defineProperty(_classNames, "".concat(prefixCls, "-active"), selectedKey === keyValue), _classNames)),
    role: "menuitem",
    style: style,
    key: keyValue
  }, mouseEvent), /*#__PURE__*/React.createElement("div", {
    className: classNames("".concat(prefixCls, "-title")),
    style: titleStyle
  }, icon && /*#__PURE__*/React.cloneElement(renderReactNodeFunction(icon), {
    className: classNames("".concat(prefixCls, "-icon"))
  }), renderTitle()));
};
var MenuItem = /*#__PURE__*/React.forwardRef(InternalMenuItem);
MenuItem.displayName = 'MenuItem';
export default MenuItem;